// Dev-only logging helpers: keep errors visible while developing,
// but produce no console output in production builds.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => { if (isDev) console.error(...args); };
export const logWarn = (...args) => { if (isDev) console.warn(...args); };
